import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useQueryClient } from 'react-query'

import ErrorBoundary from 'app/DocumentCollectionPage/components/ErrorBoundary'
import DocumentLandingPage from 'app/DocumentCollectionPage/pages/DocumentLandingPage'

export const DocumentCollectionPage = () => {
  const router = useRouter()
  const queryClient = useQueryClient()

  const resetErrorHandler = () => {
    queryClient.refetchQueries({
      queryKey: ['category-document-collection-list'],
    })
  }

  return (
    <>
      <Head>
        <title>Dokumen Rujukan - Ruang GTK</title>
      </Head>
      <ErrorBoundary resetKeys={[router.asPath]} onReset={resetErrorHandler}>
        <DocumentLandingPage />
      </ErrorBoundary>
    </>
  )
}

// eslint-disable-next-line react/display-name
DocumentCollectionPage.Layout = ({ children }) => <>{children}</>

export default DocumentCollectionPage
